const CTRL_CODE = 17;
const SHIFT_CODE = 16;
const O_LETTER_CODE = 79;
const T_LETTER_CODE = 84;

export default secretListener => {
  let storageKeys = [];
  let keydownCounter = 0;
  const passwordKeys = [
    CTRL_CODE,
    SHIFT_CODE,
    CTRL_CODE,
    SHIFT_CODE,
    O_LETTER_CODE,
    T_LETTER_CODE,
    T_LETTER_CODE,
  ];

  document.addEventListener('keydown', event => {
    const { keyCode } = event;

    if (passwordKeys[keydownCounter] === keyCode) {
      keydownCounter += 1;
      storageKeys.push(keyCode);

      if (storageKeys.toString() === passwordKeys.toString()) {
        secretListener();
        keydownCounter = 0;
        storageKeys = [];
      }
    } else {
      keydownCounter = 0;
      storageKeys = [];
    }
  });
};
